<template>
	<div class="ph-no-capture"></div>
</template>

<script>
import {
	setSubscriber,
	getSession,
	setStream,
	logMeetingEvent,
	handleCaptionReceived,
	listenForActiveSpeaker,
} from './data'
import { getOrganization } from '@/store'

const options = {
	width: '100%',
	height: '100%',
	audioVolume: 99,
	showControls: true,
	fitMode: 'contain',
	style: {
		nameDisplayMode: 'off',
		buttonDisplayMode: 'off',
		videoDisabledDisplayMode: 'off',
		backgroundImageURI: 'dfasdfasdf',
		audioBlockedDisplayMode: 'off',
		audioLevelDisplayMode: 'off',
	},
}

export default {
	name: 'subscriber',
	props: {
		stream: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			subscriber: null,
		}
	},
	emits: ['stream'],
	async mounted() {
		const session = getSession()
		const subscriber = session.subscribe(
			this.stream,
			this.$el,
			options,
			(err) => {
				if (!err) {
					setSubscriber(subscriber)
					this.$emit('stream', subscriber.stream)
				}
			}
		)

		this.subscriber = subscriber

		subscriber.on('audioBlocked', () => {
			EventBus.$emit('browserAudioBlocked')
			logMeetingEvent('subscriber', 'audioBlocked event')
		})

		subscriber.on('audioUnblocked', () => {
			setTimeout(() => {
				listenForActiveSpeaker(subscriber)
			}, 3000)
		})

		subscriber.on('videoDisabled', ({ reason, target }) => {
			logMeetingEvent('subscriber', 'videoDisabledEvent', target)
			logMeetingEvent('subscriber', 'videoDisabledEventReason', reason)
			logMeetingEvent('subscriber', 'streamHasVideo', target.stream.hasVideo)
			setStream({
				...target.stream,
				enabledReason: null,
				disabledReason: reason,
			})
		})
		subscriber.on('videoEnabled', ({ reason, target }) => {
			logMeetingEvent('subscriber', 'videoEnabledEvent', target)
			logMeetingEvent('subscriber', 'videoEnabledEventReason', reason)
			logMeetingEvent('subscriber', 'streamHasVideo', target.stream.hasVideo)
			setStream({
				...target.stream,
				enabledReason: reason,
				disabledReason: null,
			})
		})

		subscriber.on('captionReceived', handleCaptionReceived)

		this.$onEventBus('videosessionUpdated', ({ captions_enabled }) => {
			if (!this.subscriber) return
			const isSubscribed = this.subscriber.isSubscribedToCaptions()
			if (isSubscribed === captions_enabled) return
			this.subscriber.subscribeToCaptions(!!captions_enabled).then(() => {
				logMeetingEvent(
					'subscriber',
					'subscribeToCaptions',
					captions_enabled,
					'success'
				)
			})
		})

		const org = getOrganization()
		if (org?.meetings_captions_enabled) {
			await subscriber.subscribeToCaptions(true)
		}
	},

	watch: {
		'stream.hasVideo': function (hasVideo) {
			if (this.subscriber) {
				this.subscriber.subscribeToVideo(hasVideo)
			}
		},
	},
}
</script>
